import Menu from "../../../components/Menu"
import RoundyContainer from 'components/RoundyContainer'
import EndorsementThankYou from "components/StraightThroughVehicleComp/5_EndorsementThankYou/EndorsementThankYou"
import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import { storageData } from "services/Services"
import { RemoveVehicleContextComp } from "components/StraightThroughVehicleComp/RemoveVehicleContext/RemoveVehicleContext"

const RemoveVehicleEndorsementFail = (props) => {
    const navigate = useNavigate();
    const { userData } = props.user
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for Add Vehicle Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementRemoveVehicle")) {
            navigate("/maintenance")
            return
        }
    }, [])

    return (
        <>
            <RemoveVehicleContextComp>
                <Menu Title={"REMOVE VEHICLE"} FirstName={userData.firstName} userData={userData} />
                <RoundyContainer Content={EndorsementThankYou} NoRoundy
                    params={{
                        storedData: { ...props.storedData },
                        setStoredData: props.setStoredData
                    }}
                />
            </RemoveVehicleContextComp>
        </>
    )
}

export default RemoveVehicleEndorsementFail